<style>
	.edi-allorderbill{
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.edi-allorderbill .filter {
		background-color: #cbcbcb;
		padding: .4em .5em;
		margin-bottom: 1em;
		position: relative;
	}
	.edi-allorderbill .filter .ui-search-input {
		background-color: white;
		-webkit-border-radius: .3125em;
		border-radius: .3125em;
		background-image: url('../assets/allorderbill/search.png');
		background-repeat: no-repeat;
		background-size: 25px;
		background-position: 2%;
		padding-left: 2.3em
	}
	.edi-allorderbill .filter .ui-search-input2{
		width: 90%;
	}
	.edi-allorderbill .filter .ui-search-input1{
		width: 100%;
	}
	.edi-allorderbill .filter .ui-filter-icon{
		display: inline-block;
		width: 30px;
		height: 30px;
		float: right;
		background-image: url('../assets/allorderbill/filter.png');
		background-repeat: no-repeat;
		background-size: 75%;
		background-position: center;
	}
	.edi-allorderbill .ui-listview {
		float: left;
		width: 100%;
		padding-bottom: 2em;
	}
	.edi-allorderbill .ui-listview > li{
		margin-bottom: 1em;
		float: left;
		width: 100%;
		padding-bottom: .4em 1em;
	}
	.edi-allorderbill .allorderbill-list-p{
		border-bottom: solid 1px #eee;
		font-size: 1.25em;
		padding: 0.4em 1em;
		margin: .25em 0em;
	}
	.edi-allorderbill .allorderbill-list-p span{
		float:right;
		font-size: .8em;
		font-weight: bold;
	}
	.edi-allorderbill .ui-detail-listview{
		display: flex;
		flex-wrap: wrap;
	}
	.edi-allorderbill .ui-detail-listview li{
		font-size: .8em;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		width: calc(50% - 10px);
		padding-left: 5px;
		padding-right: 5px;
		margin-top: 5px;
	}
	.edi-allorderbill .ui-detail-listview li.bill-third-no {
		width: 80%;
	}

	.edi-allorderbill .ui-detail-listview li.line2Row {
		height: auto;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		word-break: break-all;
		overflow: hidden;
		white-space: normal;
	}
	.tips-flag{
		background: #D25B47;
		border-radius: 5px;
		color: #ffffff;
		padding: 4px;
		font-size: 14px;
		margin-right: 5px;
		font-style: normal;
		font-weight: normal;
	}
	.allorderbill-total-p{
		clear: both;
		margin: 0px;
		margin-left: 52%;
		font-size: .8em;
		margin-bottom: .5em;
	}
	.allorderbill-total-p strong{
		margin:0px 10px;
		font-size: 1.5em;
		font-weight: normal;
	}
	.slide-enter-active {
	  -webkit-animation: slide-in .2s ease-out;
	  animation: slide-in .2s ease-out;
	}
	.slide-leave-active {
	  -webkit-animation: slide-out .2s ease-in;
	  animation: slide-out .2s ease-in;
	}
	@-webkit-keyframes slide-in {
	  0% {
	    left: 100%;
	  }
	  100% {
	    left: 0%;
	  }
	}
	@-webkit-keyframes slide-out {
	  0% {
	    left: 0%;
	  }
	  100% {
	    left: 100%;
	  }
	}
	@keyframes slide-in {
	  0% {
	    left: 100%;
	  }
	  100% {
	    left: 0%;
	  }
	}
	@keyframes slide-out {
	  0% {
	    left: 0%;
	  }
	  100% {
	    left: 100%;
	  }
	}
  .allorderbill-footer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    clear: both;
    width: 100%;
    color: #fff;
    height: 50px;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    box-shadow: 0 5px 10px rgba(0,0,0,.5);
  }
  .allorderbill-check-all {
    display: inline-block;
    width: 80px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #FF9800;
  }
  .allorderbill-info-right{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .allorderbill-batch{
    width: 80px;
    text-align: center;
    height: 50px;
    line-height: 50px;
  }
  .allorderbill-agree{
    background-color: #259B24;
  }
  .allorderbill-return{
    background-color: #E51C23;
  }
  .allorderbill-detail-info{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
  .allorderbill-checkbox{
    margin-left: 3%;
  }
  .allorderbill-detail-ul{
    margin: .4em 1em;
  }
  .edi-nav-edit{
    float: right;
    display: inline-block;
    margin-top: -30px;
    margin-right: 3%;
    width: 40px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 14px;
    border: 1px solid #fff;
    border-radius: 5px;
  }

</style>
<template>
<div class="edi-allorderbill">
	<nav class="edi-nav">
		<div>餐企订单</div>
		<div class="edi-nav-edit" @click="navEdit" v-if="navEditShow">{{ editContent }}</div>
	</nav>

	<div class="common-scroll" id="common-scroll" @scroll="refresh" style="bottom: 0">
		<div class="filter">
			<input class="ui-search-input" type="text" v-model="keyword" :class="{'ui-search-input2':filterShow, 'ui-search-input1': !filterShow}" @keyup.enter="enterSearch"/>
			<a v-if="filterShow" class="ui-filter-icon" @click="move"></a>
		</div>
		<div class="container">
			<!--点编辑的时候有了footer，点完成没有footer，所以判断了下  ---lzh -->
			<ul class="ui-listview" :style="editShow === true ? 'padding-bottom:3em': 'padding-bottom:0' ">
				<li v-for="(orderBill, index) in orderBills">
					<!--<router-link :to="{query: { bill_id: orderBill.id }}">-->
					<p class="allorderbill-list-p">{{orderBill.restaurant_name}}
						<span v-if="orderBill.bill_state == 10" class="grey-font">
							<i v-if="orderBill.urgent_flag == 1" class="tips-flag">加急</i>未处理
						</span>
						<span v-if="orderBill.bill_state == 11" class="aqua-font">
							<i v-if="orderBill.urgent_flag == 1" class="tips-flag">加急</i>待发货
						</span>
						<span v-if="orderBill.bill_state == 12" class="orange-font">
							<i v-if="orderBill.urgent_flag == 1" class="tips-flag">加急</i>已发货
						</span>
						<span v-if="orderBill.bill_state == 13" class="ink-font">
							<i v-if="orderBill.urgent_flag == 1" class="tips-flag">加急</i>已收货
							<span style="color: #f00; font-size: 1em; margin-left: 12px;">待确认</span>
						</span>
						<span v-if="orderBill.bill_state == 14 || orderBill.bill_state == 15 || orderBill.bill_state == 16 || orderBill.bill_state == 17" class="ink-font">
							<i v-if="orderBill.urgent_flag == 1" class="tips-flag">加急</i>已收货
							<span style="color: #25bf7a; font-size: 1em; margin-left: 12px;">已确认</span>
						</span>

						<span class="bill-state-inter">&nbsp;</span>
						<span v-if="orderBill.weight_state == 0 && showDzcScaleappFlag" class="grey-font">未称重</span>
						<span v-if="orderBill.weight_state == 1 && showDzcScaleappFlag" class="aqua-font">待称重</span>
						<span v-if="orderBill.weight_state == 2 && showDzcScaleappFlag" class="ink-font">已称重</span>
					</p>
					<div class="allorderbill-detail-info">
						<div class="allorderbill-checkbox" v-show="editShow">
							<input type="checkbox" :checked="checkedAllList.indexOf(orderBill.id)>=0"  @click="checkedOne(orderBill.id)"  class="selectAll">
						</div>
						<div class="allorderbill-detail-ul">
							<router-link :to="{ path: '/detail-bill', query: { bill_id: orderBill.id }}">
								<ul class="ui-detail-listview">
									<li>单号：{{orderBill.trans_bill_no}}</li>
									<li>订货日期：{{dateCut(orderBill.from_date)}}</li>
									<li>订货：{{orderBill.from_organ_name}}</li>
									<li>收货日期：{{dateCut(orderBill.to_date)}}</li>
									<li class="line2Row">送往：{{orderBill.to_organ_name}}</li>
									<li><span v-show="!orderBill.hiddenTax">含税</span>金额：{{orderBill.sum_money_send | toDecimal}} 元</li>
									<li class="bill-third-no" v-if="orderBill.original_bill_id">第三方单号：{{orderBill.original_bill_id}}</li>
								</ul>
							</router-link>
						</div>
					</div>
					<p class="allorderbill-total-p">共<strong>{{orderBill.detail_num}}</strong>种品项</p>
					<!--</router-link>-->
				</li>
			</ul>
		</div>
		<refresh v-show="!show" :cls="cls" :font="font"></refresh>
		<mid-ware v-show="midware" :icon="icon" :midFont="midFont"></mid-ware>
	</div>
	<div class="allorderbill-footer" v-show="editFootShow">
		<div class="allorderbill-info-left" >
			<span class="allorderbill-check-all" @click="checkedAll">{{ checkAllContent}}</span>
		</div>
		<div class="allorderbill-info-right">
			<div class="allorderbill-batch allorderbill-agree" @click="batch('同意')" v-if="this.billState == 10">
				批量同意
			</div>
			<div class="allorderbill-batch allorderbill-agree" @click="batch('发货')" v-if="this.billState == 11">
				批量发货
			</div>
			<div class="allorderbill-batch allorderbill-return" @click="batch('退回')">
				批量退回
			</div>
		</div>
	</div>
	<loading v-show="loading"></loading>
	<tipsAuto-hasMiddleStyle v-show="tipsauto" :tipsFont="tipsFont" :tipsAutoIco="tipsAutoIco" ></tipsAuto-hasMiddleStyle>
	<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
	<tips v-show="tipss" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatusB"></tips>
	<bill-filter v-if="filterShow" :filterBillFont="queryData.bill_font" :filterBillState="queryData.bill_state" :filterSort="sort" :filterSortFont="sortFont" :filterStarDate="queryData.start_date" :filterEndDate="queryData.end_date" ref="billFilterOpen" v-on:confirm="backValue"></bill-filter>
</div>
</template>
<script>
import BillFilter from '../components/BillFilter'
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto.vue'
import TipsAutoHasMiddleStyle from '../components/TipsAutoHasMiddleStyle.vue'
import MidWare from '../components/MidWare'
import Refresh from '../components/refresh'
import NavBar from '../components/NavBar'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			filterShow: true,
			show: true,
			cls: '',
			font: '',
			midware: true,
			icon: '',
			midFont: '',
			loading: true,
			tips: false,
			tipss: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			queryData: this.$route.query,
			orderBills: [],
			bill_type: 1,
			keyword: '',
			length: 10,
			start: 0,
			filterData: {},
			prevLength: 0,
			start_date: '',
			end_date: '',
			sort: '1',
			sortFont: '到货日期',
			billState: '',
			billStateFont: '',
			store: GlobalStore,
			goodsTotalInfo: {},
			billFilterData: {},
			editShow: false,
			editFootShow: false,
			editContent: '编辑',
			checkAllContent: '全选',
			isCheckedAll: false,
			checkedAllList: [],
			isChecked: false,
			noCheckedAllList: [],
			result: '',
			tipsauto: false,
			tipsAutoIco: 'tips-auto-remind-icon',
			msgs: '',
			sec: 3000,
			navEditShow: true,
			showDzcScaleappFlag: false
		}
	},
	components: {
		'bill-filter': BillFilter,
		'loading': Loading,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'mid-ware': MidWare,
		'refresh': Refresh,
		'navbar': NavBar,
		'tipsAuto-hasMiddleStyle': TipsAutoHasMiddleStyle
	},
	filters: {
		toDecimal (value) {
			if (!value) {
				return 0
			}
			return parseFloat(value).toFixed(2)
		}
	},
	created () {
		this.goodsTotalInfo = this.store.goodsTotalInfo
		this.filterShow = this.goodsTotalInfo.filterShow
		this.goodsTotalInfo.queryData = this.queryData
		// 如果有筛选条件,按照筛选条件查询 shang 2017/10/19
		this.billFilterData = this.store.billFilterData
		if (this.billFilterData.filterFlag) {
			this.queryData.bill_state = this.billFilterData.filterBillState
			this.queryData.bill_font = this.billFilterData.filterBillStateFont
			this.queryData.start_date = this.billFilterData.filterStartDate
			this.queryData.end_date = this.billFilterData.filterEndDate
			this.start_date = this.billFilterData.filterStartDate
			this.end_date = this.billFilterData.filterEndDate
			this.sort = this.billFilterData.filterBillSort
			this.sortFont = this.billFilterData.filterBillSortFont
		}
		if (!this.start_date) {
			this.start_date = this.queryData.start_date
		}
		if (!this.end_date) {
			this.end_date = this.queryData.end_date
		}
		this.billState = this.queryData.bill_state
		this.billStateFont = this.queryData.bill_font
		this.loading = true
		this.midware = false
		var billState = this.queryData.bill_state
		var billType = this.queryData.bill_type
		var endDate = this.end_date
		var startDate = this.start_date
		var sortMethod = this.queryData.sort_method
		var restaurantId = this.queryData.restaurant_id
		var organId = this.queryData.organ_id
		var goodsId = this.queryData.goods_id
		var goodsUnit = this.queryData.goods_unit
		var keyWord = this.keyword
		this.filterData = {
			bill_state: billState,
			start_date: startDate,
			end_date: endDate,
			bill_type: billType,
			keyword: keyWord,
			date_type: sortMethod,
			goods_unit: goodsUnit,
			restaurant_id: restaurantId,
			organ_id: organId,
			goods_id: goodsId,
			length: 10,
			start: 0
		}
		const filters = this.queryData.bill_state.toString()
		if (filters.search('12') !== -1 || filters.search('13') !== -1 || filters.search('14') !== -1) {
			this.navEditShow = false
			this.editFootShow = false
		} else {
			this.navEditShow = true
		}
		this.$http.post('/cldEdi/business/billList', this.filterData).then((response) => {
			this.loading = false
			this.orderBills = response.body.data
			// window.console.log(this.prevLength)
			if (this.orderBills === null) {
				this.midware = true
				this.icon = 'middle-empty'
				this.midFont = '没有数据'
				return false
			}
			this.prevLength = this.orderBills.length
		}, (response) => {
			this.loading = false
			this.midware = true
			this.icon = 'middle-net'
			this.midFont = '服务中断，稍后请重试！'
		})
	},
	methods: {
		// 弹窗 ---lzh
		autoTips (msg) {
			const self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		batch (msg) {
			if (this.checkedAllList.length > 0) {
				this.tipss = true
				this.btnNum = 3
				this.tipsFont = '确定对已选中单据进行批量' + msg + '操作？'
				this.msgs = msg
			} else {
				this.autoTips('请选择至少一条数据！')
			}
		},
		tipStatusB (msg) {
			this.tipss = false
			this.msg = msg
			switch (this.msgs) {
			case '同意':
				if (this.msg[1] === true) {
					this.loading = true
					this.batchAgree()
				}
				break
			case '发货':
				if (this.msg[1] === true) {
					this.loading = true
					this.batchGoods()
				}
				break
			case '退回':
				if (this.msg[1] === true) {
					this.loading = true
					this.batchReturn()
				}
			}
		},
		// 按钮编辑全选、批量同意、批量退回 ---lzh
		navEdit () {
			if (this.editShow === false) {
				this.editShow = true
				this.editFootShow = true
				this.editContent = '完成'
			} else {
				this.editShow = false
				this.editFootShow = false
				this.editContent = '编辑'
			}
		},
		checkedAll () {
			this.isCheckedAll = !this.isCheckedAll
			if (this.isCheckedAll) { // 全选
				this.checkAllContent = '取消全选'
				this.checkedAllList = []
				for (let orderBill of this.orderBills) {
					this.checkedAllList.push(orderBill.id)
				}
			} else {
				this.checkAllContent = '全选'
				this.checkedAllList = []
			}
		},
		checkedOne (orderBillId) {
			const idIndex = this.checkedAllList.indexOf(orderBillId)
			if (this.isCheckedAll) {
				this.noCheckedAllList.push(orderBillId)
			} else {
				this.noCheckedAllList = []
			}
			this.noCheckedAllList = Array.from(new Set(this.noCheckedAllList)) // 数组去重
			if (idIndex >= 0) {
				// 如果已经包含了该id, 则去除
				this.checkedAllList.splice(idIndex, 1)
				if (this.checkedAllList.length <= 0) { // 在全选下选中的数据为空，全选模式退出
					this.isCheckedAll = false
					this.checkAllContent = '全选'
				}
			} else {
			// 选中该checkbox
				this.checkedAllList.push(orderBillId)
			}
			this.checkedAllList = Array.from(new Set(this.checkedAllList))
		},
		batchAgree () {
			const $method = this.$options.methods
			const operate = 1
			if (this.noCheckedAllList.length <= 0) {
				$method.checkAllPost(this, this.isCheckedAll, 11, operate, this.checkedAllList)
			} else {
				$method.checkAllPost(this, this.isCheckedAll, 11, operate, this.noCheckedAllList)
			}
		},
		batchGoods () {
			const $method = this.$options.methods
			const operate = 3
			if (this.noCheckedAllList.length <= 0) {
				$method.checkAllPost(this, this.isCheckedAll, 12, operate, this.checkedAllList)
			} else {
				$method.checkAllPost(this, this.isCheckedAll, 12, operate, this.noCheckedAllList)
			}
		},
		batchReturn () {
			const $method = this.$options.methods
			const operate = 2
			if (this.noCheckedAllList.length <= 0) {
				$method.checkAllPost(this, this.isCheckedAll, 19, operate, this.checkedAllList)
			} else {
				$method.checkAllPost(this, this.isCheckedAll, 19, operate, this.noCheckedAllList)
			}
		},
		checkAllPost (_this, isCheckedAll, billState, operate, params) {
			let data = JSON.stringify(params)
			if (_this.isCheckedAll) {
				if (_this.noCheckedAllList.length > 0) {
					data = JSON.stringify(_this.noCheckedAllList)
				} else {
					data = []
				}
			}
			_this.$http.post('/cldEdi/business/bill/updateBillState?is_batch=true&is_all=' + isCheckedAll + '&target_bill_state=' + billState + '&operate=' + operate, data).then((response) => {
				const success = response.body.data.success
				const fail = response.body.data.fail
				const rtnMsg = response.body.data.msg
				let processSeconds = 0
				let autoTipInfo = '【批量' + _this.msgs + '】操作完成：成功[' + success + ']条，失败[' + fail + ']条。\n'
				if (rtnMsg) {
					autoTipInfo += rtnMsg
				}
				_this.autoTips(autoTipInfo)

				if (operate === 2 || operate === 3) {
					processSeconds = this.batchReturnMsgProcess(_this, response)
				}

				setTimeout(function () {
					_this.$router.go(0)
				}, 3100 + processSeconds)
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		},
		batchReturnMsgProcess (_this, response) {
			const resMsg = JSON.parse(response.bodyText)
			const resMsgData = resMsg && resMsg.data && resMsg.data.msg
			let processSeconds = 0
			if (resMsgData.length > 0) {
				processSeconds = _this.sec
				let autoTipInfo = ''
				let info = resMsgData[0].split(',')
				const MaxLength = 4

				let i = 1
				for (; i < MaxLength; i++) {
					if (!info[i]) {
						break
					}
					autoTipInfo += info[i]
				}
				autoTipInfo += info[0]
				for (var j = i, k = 1; j < MaxLength; j++, k++) {
					if (resMsgData[k]) {
						autoTipInfo += resMsgData[k]
					}
					++j // 占两次循环
				}

				setTimeout(function () {
					_this.autoTips(autoTipInfo)
				}, processSeconds)
			}
			return processSeconds
		},
		move () {
			var obj = {
				order_state: this.billState,
				order_state_font: this.billStateFont,
				sort: this.sort,
				sortFont: this.sortFont
			}
			this.$refs.billFilterOpen.move(obj)
		},
		dateCut (val) {
			if (val) {
				var arr = val.split(' ')
				return arr[0]
			}
		},
		refresh () {
			// debugger
			var el = document.getElementById('common-scroll')
			var marginBot = el.scrollHeight - (el.scrollTop + document.body.scrollTop) - el.clientHeight
			// console.log(this.orderBills)
			// console.log(this.start)
			if (marginBot <= 10) {
				this.show = false
				// 修复bug prevLength获取有延迟 避免读取数据时多次调用接口 shang 2017/9/28
				if (this.prevLength < 10 || this.orderBills.length < (this.start + 1) * 10) {
					this.cls = 'remind'
					this.font = '已经没有数据'
					var self = this
					setTimeout(() => {
						self.show = true
					}, 1500)
					return false
				}
				this.cls = 'update'
				this.font = '加载中...'
				this.start ++
				var start = this.start * 10
				var billState = this.queryData.bill_state
				var billType = this.bill_type
				// var startDate = this.queryData.start_date
				// var endDate = this.queryData.end_date
				// 修复bug,这里的开始,结束日期应该使用搜索的日期 shang 2017/9/27
				var startDate = this.start_date
				var endDate = this.end_date
				var sortMethod = this.queryData.sort
				var keyWord = this.keyword

				this.filterData = {
					bill_state: billState,
					start_date: startDate,
					end_date: endDate,
					bill_type: billType,
					keyword: keyWord,
					sort: sortMethod,
					start: start,
					length: 10
				}
				this.$http.post('/cldEdi/business/billList', this.filterData).then((response) => {
					var data = response.body.data
//					console.log(data)
					// for (let data1 of data) {
					// 	this.checkedAllList.push(data1.id)
					// }
//					console.log(this.checkedAllList)
					this.show = true
					// 修复bug 当data为null 无法取到length shang 2017/9/28
					if (data !== null) {
						this.prevLength = data.length
						// window.console.log(this.prevLength)
						this.orderBills = this.orderBills.concat(data)
					} else {
						this.prevLength = 0
					}
				}, (response) => {
					this.loading = false
					this.midware = true
					this.icon = 'middle-net'
					this.midFont = '服务中断，稍后请重试！'
				})
			}
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		backValue (msg) {
			// window.console.log(msg)
			this.sort = msg.sort
			this.sortFont = msg.sortFont
			this.billState = msg.bill_state
			this.bill_state = msg.bill_state
			this.queryData.bill_state = msg.bill_state
			this.billStateFont = msg.bill_state_font
			this.start_date = msg.start_date
			this.end_date = msg.end_date
			this.search()
		},
		search () {
			this.loading = true
			this.midware = false
			var billState = this.bill_state
			var startDate = this.start_date
			var billType = this.bill_type
			var endDate = this.end_date
			var sortMethod = this.sort
			var keyWord = this.keyword
			this.filterData = {
				bill_state: billState,
				start_date: startDate,
				end_date: endDate,
				bill_type: billType,
				keyword: keyWord,
				sort: sortMethod,
				length: 10,
				start: 0
			}
			// this.$router.push({path: '/all-order-bill', query: this.filterData})
			this.$http.post('/cldEdi/business/billList', this.filterData).then((response) => {
				const filters = this.bill_state
				if (filters.search('12') !== -1 || filters.search('13') !== -1) {
					this.navEditShow = false
					this.editFootShow = false
					this.editShow = false
				} else {
					this.navEditShow = true
					this.editFootShow = false
					this.editShow = false
					this.editContent = '编辑'
				}
				this.loading = false
				this.orderBills = response.body.data
				if (this.orderBills === null) {
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				}
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		},
		// 搜索栏回车搜索,实现明细退回单据主页面,依然存在搜索条件 shang 2017/10/19
		enterSearch () {
			this.loading = true
			this.midware = false
			var billState = this.queryData.bill_state
			var billType = this.bill_type
			var startDate = this.start_date
			var endDate = this.end_date
			var sortMethod = this.queryData.sort
			var keyWord = this.keyword
			this.filterData = {
				bill_state: billState,
				start_date: startDate,
				end_date: endDate,
				bill_type: billType,
				keyword: keyWord,
				sort: sortMethod,
				length: 10,
				start: 0
			}
			// this.$router.push({path: '/all-order-bill', query: this.filterData})
			this.$http.post('/cldEdi/business/billList', this.filterData).then((response) => {
				this.loading = false
				this.orderBills = response.body.data
				if (this.orderBills === null) {
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				}
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// AllOrderBill.vue?32ec1e0c